import { useContext, useEffect } from "react";
import { Table } from "react-bootstrap";
import { isEmpty } from "lodash";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

import Breadcrumbs from "../../../utils/Breadcrumbs/Breadcrumbs";
import SiteTitle from "../../../utils/SiteTitle/SiteTitle";
import EmptyData from "../../../utils/EmptyData/EmptyData";
import CardLayout from "../../../utils/CardLayout/CardLayout";
import PaginationList from "../../../utils/PaginationList/PaginationList";
import CustomModal from "./../../../utils/CustomModal/CustomModal";
import ItemInfo from "./../../../utils/ItemInfo/ItemInfo";
import {
  convertDate,
  numberSeparate,
  paymentStatusItems,
} from "../../../utils";
import { areYouSureMessage } from "../../../utils/toastMessage/toastMessage";
import { invoiceAdminContext } from "../../../context/Admin/InvoiceAdminContext/InvoiceAdminContext";
import { ConvertCurrency } from "../../../utils/Currency/Currency";

const InvoiceAdmin = () => {
  const permission = useSelector((state) => state.permission);

  const { pathname } = useLocation();

  const {
    invoices,
    invoice,
    search,
    setSearch,
    limit,
    setLimit,
    totalCount,
    pageNumber,
    setPageNumber,
    handleGetInvoices,
    handleGetInvoice,
    handleDeleteInvoice,
    handleCloseInvoiceModal,
  } = useContext(invoiceAdminContext);

  useEffect(() => {
    handleGetInvoices();
  }, [pageNumber, limit]);

  const onNavigate = (pk) => {
    window.open(`${pathname?.replace("Invoice", "Orders")}/${pk}`, "_blank");
  };

  return (
    <>
      <SiteTitle title="فاکتورها" />
      <Breadcrumbs
        navs={[
          { name: "داشبورد", url: "/Admin/Dashboard", type: "l" },
          { name: "فاکتورها", type: "a" },
        ]}
        title="لیست فاکتورها"
      />

      <CardLayout>
        <form className="input-group mb-3" onSubmit={handleGetInvoices}>
          <input
            type="text"
            name="search"
            autoComplete="off"
            placeholder="جستجو ..."
            className="form-control"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <div className="input-group-append">
            <button type="submit" className="btn btn-primary">
              جستجو
            </button>
          </div>
        </form>
        {isEmpty(invoices) ? (
          <EmptyData />
        ) : (
          <>
            <div className="d-flex justify-content-between align-items-center">
              <PaginationList
                setPageNumber={setPageNumber}
                pageCount={totalCount / limit}
              />
              <div>
                <select
                  className="form-control mb-3"
                  onChange={(e) => setLimit(Number(e.target.value))}
                >
                  <option value={10} selected={10 === limit}>
                    10
                  </option>
                  <option value={25} selected={25 === limit}>
                    25
                  </option>
                  <option value={50} selected={50 === limit}>
                    50
                  </option>
                  <option value={75} selected={75 === limit}>
                    75
                  </option>
                  <option value={100} selected={100 === limit}>
                    100
                  </option>
                </select>
              </div>
            </div>
            <Table responsive hover borderless striped>
              <thead className="thead-dark text-center">
                <tr>
                  <th>#</th>
                  <th>نام و نام خانوادگی</th>
                  <th>نام کاربری</th>
                  <th>شماره موبایل</th>
                  <th>نوع خدمت</th>
                  <th>کد پیگیری سفارش</th>
                  <th>تاریخ ایجاد سفارش</th>
                  <th>مبلغ (ريال)</th>
                  <th className="text-center">
                    تعداد کل :{" "}
                    <span className="badge badge-primary font-weight-bold p-1">
                      {totalCount}
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody className="text-center">
                {invoices.map((_item, index) => (
                  <tr>
                    <td>{index + 1}</td>
                    <td>
                      {_item?.order?.client?.first_name}{" "}
                      {_item?.order?.client?.last_name}
                    </td>
                    <td>{_item?.order?.client?.username}</td>
                    <td>{_item?.order?.client?.mobile}</td>
                    <td>{_item?.order?.service}</td>
                    <td>{_item?.order?.ref_num}</td>
                    <td>{convertDate(_item?.order?.created)}</td>
                    <td>
                      <span className="font-weight-bold">
                        <ConvertCurrency price={_item?.total} />
                      </span>
                    </td>
                    <td>
                      <button
                        onClick={() => onNavigate(_item?.order?.pk)}
                        className="btn btn-primary mr-2"
                        disabled={!_item?.order?.pk}
                      >
                        سفارش
                      </button>
                      {permission.invoices_get && (
                        <button
                          onClick={() => handleGetInvoice(_item?.pk)}
                          className="btn btn-info mr-2"
                        >
                          جزئیات
                        </button>
                      )}
                      {permission.invoices_destroy && (
                        <i
                          onClick={() =>
                            areYouSureMessage(
                              () => handleDeleteInvoice(_item),
                              `آیا از حذف کیف پول ${_item?.order?.client?.first_name} ${_item?.order?.client?.last_name} اطمینان دارید؟`
                            )
                          }
                          className="fa fa-trash-alt fa-2x text-danger cursorPointer"
                        />
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </>
        )}
      </CardLayout>

      {/* Start Details Modal */}
      <CustomModal
        title="جزئیات پرداخت"
        show={!isEmpty(invoice)}
        onHide={handleCloseInvoiceModal}
        size="xl"
      >
        <div className="container">
          <div>
            <p className="text-info fw-bold text-center">اطلاعات سفارش</p>

            <div className="row">
              <ItemInfo label="نام و نام خانوادگی">
                <p>
                  {invoice?.order?.client?.first_name}{" "}
                  {invoice?.order?.client?.last_name}
                </p>
              </ItemInfo>
              <ItemInfo label="شماره موبایل">
                <p>{invoice?.order?.client?.mobile}</p>
              </ItemInfo>
              <ItemInfo label="نام کاربری">
                <p>{invoice?.order?.client?.username}</p>
              </ItemInfo>
              <ItemInfo label="نوع خدمت">
                <p>{invoice?.order?.service}</p>
              </ItemInfo>
              <ItemInfo label="کد پیگیری سفارش">
                <p>{invoice?.order?.ref_num}</p>
              </ItemInfo>
            </div>

            <hr />
          </div>
          {invoice?.payment?.map((item, index) => (
            <div key={index}>
              <p className="text-info fw-bold text-center">
                اطلاعات پرداخت {index + 1}
              </p>

              <div className="row">
                <ItemInfo label="مبلغ">
                  <ConvertCurrency price={item?.amount} />
                </ItemInfo>
                <ItemInfo label="شماره کارت">
                  <p>{item?.cardnumbermasked}</p>
                </ItemInfo>
                <ItemInfo label="توضیحات">
                  <p>{item?.description}</p>
                </ItemInfo>
                <ItemInfo label="پیغام">
                  <p>{item?.message}</p>
                </ItemInfo>
                <ItemInfo label="تاریخ ایجاد">
                  <p>{item?.created_time}</p>
                </ItemInfo>
                <ItemInfo label="وضعیت">
                  <p>{paymentStatusItems[item?.status]}</p>
                </ItemInfo>
                <ItemInfo label="توکن">
                  <p>{item?.token}</p>
                </ItemInfo>
                <ItemInfo label="شماره ترمینال">
                  <p>{item?.terminalno}</p>
                </ItemInfo>
                <ItemInfo label="کدپیگیری">
                  <p>{item?.paygatetranid}</p>
                </ItemInfo>
                <ItemInfo label="rrn">
                  <p>{item?.rrn}</p>
                </ItemInfo>
              </div>

              <hr />
            </div>
          ))}
          <div>
            <p className="text-info fw-bold text-center">فاکتور</p>

            <div className="row align-items-center">
              <ItemInfo label="شماره فاکتور">
                {numberSeparate(invoice?.pk)}
              </ItemInfo>

              <ItemInfo label="اجرت (ریال)">
                <ConvertCurrency price={invoice?.fee} />
              </ItemInfo>

              <ItemInfo label="هزینه قطعه (ریال)">
                <ConvertCurrency price={invoice?.piece} />
              </ItemInfo>

              <ItemInfo label="ایاب و ذهاب (ریال)">
                <ConvertCurrency price={invoice?.transportation} />
              </ItemInfo>
              <ItemInfo label="مالیات (ریال)">
                <ConvertCurrency price={invoice?.tax} />
              </ItemInfo>
              <ItemInfo label="تخفیف (ریال)">
                <ConvertCurrency price={invoice?.discount?.amount} />
              </ItemInfo>
              <ItemInfo label="فاکتور رسمی">
                <i
                  className={`fa fa-${
                    invoice?.is_official ? "check" : "times"
                  } text-${invoice?.is_official ? "success" : "danger"}`}
                />
              </ItemInfo>
              <ItemInfo label="پرداخت شده">
                <i
                  className={`fa fa-${
                    invoice?.is_paid ? "check" : "times"
                  } text-${invoice?.is_paid ? "success" : "danger"}`}
                />
              </ItemInfo>

              <ItemInfo label="نوع پرداخت">
                <p>
                  {invoice?.method === 1
                    ? "اعتبار (کیف پول)"
                    : invoice?.method === 2
                    ? "درگاه پرداخت"
                    : "نقدی"}
                </p>
              </ItemInfo>

              <ItemInfo label="مجموع (ریال)">
                <ConvertCurrency price={invoice?.total} />
              </ItemInfo>
              <ItemInfo label="توضیحات">
                <p>{invoice?.description}</p>
              </ItemInfo>
              {!isEmpty(invoice?.items) && (
                <div className="col-12">
                  <Table responsive hover borderless>
                    <thead className="thead-light">
                      <th>عنوان</th>
                      <th>مبلغ (ریال)</th>
                      <th>توضیحات</th>
                    </thead>
                    <tbody>
                      {invoice?.items?.map((_inv, idx) => (
                        <tr key={idx}>
                          <td>{_inv.name}</td>
                          <td>
                            <ConvertCurrency price={_inv?.price} />
                          </td>
                          <td>{_inv.description}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              )}
            </div>
          </div>
        </div>
      </CustomModal>
      {/* End Details Modal */}
    </>
  );
};

export default InvoiceAdmin;
